import { BOTTOM, LEFT, RIGHT, TOP } from '../constants';
import { getChildrenForCurrentNode, getClosestDndArea, getDeepestHoveredNode, getLayoutTreeChildrenMaps
// @ts-expect-error not yet migrated
} from './layoutTreeHoverPositionUtils';
import { determineLeftOrRightHalfPositionWithinBounds, determinePositionTriangleWithinBounds, determineTopOrBottomHalfPositionWithinBounds
// @ts-expect-error not yet migrated
} from '../geometry/triangle';
import { buildHoverPositionForAfterChildren, buildHoverPositionForBeforeChildren, buildHoverPositionForBetweenSiblings, buildHoverPositionForSectionContainerBuffer, buildHoverPositionForWithinBoundsOfNode, computeClosenessToAllEdges, getNextDirectSiblingOfGridNode, getParentNode, getPreviousDirectSiblingOfGridNode, isBetweenTwoDirectSiblings, isFirstChildOfContainer, isLastChildOfContainer } from './gridLayoutTreeHoverPositionUtils';
import { GRID_LAYOUT_SECTION_CONTAINER_BUFFER_SIZE, layoutNodeTypes } from '../constants/dndAreaHoverPositionConstants';
import { isPositionWithinBounds, getIsPositionInBufferOfBounds } from '../geometry/basic';
const getHoverLocations = (currentNodeToCheck, adjustedMouseCoords) => {
  return {
    topOrBottomHovered: determineTopOrBottomHalfPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck),
    leftOrRightHovered: determineLeftOrRightHalfPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck),
    triangleHovered: determinePositionTriangleWithinBounds(adjustedMouseCoords, currentNodeToCheck)
  };
};
const getSiblings = (currentNodeToCheck, mapOfChildIdsByParentId, mapOfPositionsById) => {
  var _getPreviousDirectSib, _getNextDirectSibling;
  return {
    previousSiblingId: (_getPreviousDirectSib = getPreviousDirectSiblingOfGridNode({
      currentNodeToCheck,
      mapOfChildIdsByParentId,
      mapOfPositionsById
    })) === null || _getPreviousDirectSib === void 0 ? void 0 : _getPreviousDirectSib.id,
    nextSiblingId: (_getNextDirectSibling = getNextDirectSiblingOfGridNode({
      currentNodeToCheck,
      mapOfChildIdsByParentId,
      mapOfPositionsById
    })) === null || _getNextDirectSibling === void 0 ? void 0 : _getNextDirectSibling.id
  };
};
const calculateGridLayoutTreeHoverPositions = (nodePositions, adjustedMouseCoords, {
  includeEmptySectionHoverPositions,
  outsideBufferOverride
}) => {
  const rootAreaIds = Object.keys(nodePositions);
  if (rootAreaIds.length === 0) {
    return [];
  }
  const hoveredStack = []; // stack of all the nodes hovered over, in ascending depth order
  const nodesToCheck = [];
  const rootGridLayoutTreePositions = [];
  let activeNodePositions = []; // Node positions for the grid layout that is either hoveredOver, or closest to the mouse

  // Get the positions for the grid layout that is hovered over, if there is one.
  // Also build the root grid layout positions array
  rootAreaIds.forEach(key => {
    const nodePos = nodePositions[key][0];
    if (nodePos && nodePos.depth === 0) {
      if (isPositionWithinBounds(adjustedMouseCoords, nodePos)) {
        activeNodePositions = nodePositions[key];
      }
      rootGridLayoutTreePositions.push(nodePos);
    } else {
      console.log('The first index in a node position array must be the root node');
    }
  });
  const {
    mapOfPositionsById,
    mapOfChildrenById: mapOfChildIdsByParentId
  } = getLayoutTreeChildrenMaps(activeNodePositions);

  // If we are not hovering directly over any grid layout sections, determine
  // hover positions based off whichever grid layout section is the closest.
  // If we are, then add the first (depth 0) node position to the nodes to
  // check
  let closestLayoutTreeId;
  let relativeLocation;
  if (!activeNodePositions.length) {
    const closestLayoutTreeData = getClosestDndArea(rootGridLayoutTreePositions, adjustedMouseCoords, outsideBufferOverride);
    closestLayoutTreeId = closestLayoutTreeData.closestLayoutTreeId;
    relativeLocation = closestLayoutTreeData.relativeLocation;
    if (closestLayoutTreeId && relativeLocation) {
      activeNodePositions = nodePositions[closestLayoutTreeId];
      // First push info for the closest grid layout section, which is now the
      // root
      hoveredStack.push({
        id: closestLayoutTreeId,
        gridLayoutId: closestLayoutTreeId,
        depth: 0,
        // @ts-expect-error TODO Come back to this
        inBufferZone: true
      });
    }
  } else {
    nodesToCheck.push(activeNodePositions[0]);
  }
  let previousSibling = null;
  const deepestHoveredNode = getDeepestHoveredNode(nodesToCheck, mapOfChildIdsByParentId, mapOfPositionsById, adjustedMouseCoords);
  while (nodesToCheck.length > 0) {
    const currentNodeToCheck = nodesToCheck.shift();
    const parentNode = getParentNode(currentNodeToCheck, mapOfPositionsById);
    if (currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_GRID) {
      if (
      // TODO: We should remove this flag once we've fully moved onto editor 2.0 and this is the default functionality
      !includeEmptySectionHoverPositions && currentNodeToCheck.numChildren === 0 && (parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) === layoutNodeTypes.GRID_LAYOUT_SECTION) {
        // Short circuit in this case as we want to render a custom generate section UI instead of rendering any overlays
        return [];
      }
    }
    previousSibling = getPreviousDirectSiblingOfGridNode({
      currentNodeToCheck,
      mapOfChildIdsByParentId,
      mapOfPositionsById
    });

    // If mouse is directly over the bounds of a node
    if (isPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck)) {
      const hoverLocations = getHoverLocations(currentNodeToCheck, adjustedMouseCoords);
      const closenessToAllEdges = computeClosenessToAllEdges(Object.assign({
        adjustedMouseCoords,
        currentNodeToCheck,
        deepestHoveredNode
      }, hoverLocations));
      const siblings = getSiblings(currentNodeToCheck, mapOfChildIdsByParentId, mapOfPositionsById);
      const children = getChildrenForCurrentNode(currentNodeToCheck.id, mapOfChildIdsByParentId, mapOfPositionsById);
      nodesToCheck.push(...children);
      let childrenIds = {};
      if (currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_GRID || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
        var _children$, _children$at;
        childrenIds = {
          firstChildId: (_children$ = children[0]) === null || _children$ === void 0 ? void 0 : _children$.id,
          lastChildId: (_children$at = children.at(-1)) === null || _children$at === void 0 ? void 0 : _children$at.id
        };
      }
      const newHoverPosition = buildHoverPositionForWithinBoundsOfNode(currentNodeToCheck, Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds));
      if (newHoverPosition) {
        hoveredStack.push(newHoverPosition);
      }
    }
    // Check if mouse is hovering the outer buffer area of the "Section Container" node.
    else if ((currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK || currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK) && (parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) === layoutNodeTypes.GRID_LAYOUT_SECTION) {
      const bufferBounds = getIsPositionInBufferOfBounds(adjustedMouseCoords, currentNodeToCheck, GRID_LAYOUT_SECTION_CONTAINER_BUFFER_SIZE);
      if (bufferBounds) {
        const newHoverPosition = buildHoverPositionForSectionContainerBuffer({
          node: currentNodeToCheck,
          bufferBounds
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
      }
    } else if (
    // Check if mouse is in space between two direct siblings on same axis
    currentNodeToCheck.type !== layoutNodeTypes.GRID_LAYOUT_ROOT && parentNode && previousSibling && isBetweenTwoDirectSiblings({
      adjustedMouseCoords,
      currentNodeToCheck,
      mapOfPositionsById,
      previousSibling
    })) {
      var _children$2, _children$at2;
      const hoverLocations = getHoverLocations(parentNode, adjustedMouseCoords);
      const closenessToAllEdges = computeClosenessToAllEdges(Object.assign({
        adjustedMouseCoords,
        currentNodeToCheck: parentNode,
        deepestHoveredNode
      }, hoverLocations));
      const siblings = getSiblings(parentNode, mapOfChildIdsByParentId, mapOfPositionsById);
      const children = getChildrenForCurrentNode(parentNode.id, mapOfChildIdsByParentId, mapOfPositionsById);
      const childrenIds = {
        firstChildId: (_children$2 = children[0]) === null || _children$2 === void 0 ? void 0 : _children$2.id,
        lastChildId: (_children$at2 = children.at(-1)) === null || _children$at2 === void 0 ? void 0 : _children$at2.id
      };
      const newHoverPosition = buildHoverPositionForBetweenSiblings({
        node: currentNodeToCheck,
        otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds),
        parentNode,
        previousSibling
      });
      if (newHoverPosition) {
        hoveredStack.push(newHoverPosition);
      }
    } else if (currentNodeToCheck.type !== layoutNodeTypes.GRID_LAYOUT_ROOT && parentNode && parentNode.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK) {
      var _children$3, _children$at3;
      const hoverLocations = getHoverLocations(parentNode, adjustedMouseCoords);
      const closenessToAllEdges = computeClosenessToAllEdges(Object.assign({
        adjustedMouseCoords,
        currentNodeToCheck: parentNode,
        deepestHoveredNode
      }, hoverLocations));
      const siblings = getSiblings(parentNode, mapOfChildIdsByParentId, mapOfPositionsById);
      const children = getChildrenForCurrentNode(parentNode.id, mapOfChildIdsByParentId, mapOfPositionsById);
      const childrenIds = {
        firstChildId: (_children$3 = children[0]) === null || _children$3 === void 0 ? void 0 : _children$3.id,
        lastChildId: (_children$at3 = children.at(-1)) === null || _children$at3 === void 0 ? void 0 : _children$at3.id
      };
      const firstChildOfContainer = isFirstChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeToCheck.id);
      const lastChildOfContainer = isLastChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeToCheck.id);
      const isWithinHorizontalSpaceOfNode = isPositionWithinBounds(adjustedMouseCoords, {
        top: parentNode.top,
        bottom: parentNode.bottom,
        left: currentNodeToCheck.left,
        right: currentNodeToCheck.right
      });
      const leftOrRightOfNode = determineLeftOrRightHalfPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck);
      const leftOfChild = adjustedMouseCoords.x < currentNodeToCheck.left;
      const leftOfChildHorizontalSpace = isWithinHorizontalSpaceOfNode && leftOrRightOfNode === LEFT;
      const rightOfChild = adjustedMouseCoords.x > currentNodeToCheck.right;
      const rightOfChildHorizontalSpace = isWithinHorizontalSpaceOfNode && leftOrRightOfNode === RIGHT;
      if (
      // Is the cursor to the left of the first element inside a horizontal stack
      firstChildOfContainer && (leftOfChild || leftOfChildHorizontalSpace)) {
        const newHoverPosition = buildHoverPositionForBeforeChildren({
          node: parentNode,
          childrenIds,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds)
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
      } else if (
      // Is the cursor to the right of the last element inside a horizontal stack
      lastChildOfContainer && (rightOfChild || rightOfChildHorizontalSpace)) {
        const newHoverPosition = buildHoverPositionForAfterChildren({
          node: parentNode,
          childrenIds,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds)
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
        // Is the cursor above/below the left half of an element inside a horizontal stack
      } else if (leftOfChildHorizontalSpace) {
        const newHoverPosition = buildHoverPositionForBetweenSiblings({
          node: currentNodeToCheck,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds),
          parentNode,
          previousSibling: getPreviousDirectSiblingOfGridNode({
            currentNodeToCheck,
            mapOfChildIdsByParentId,
            mapOfPositionsById
          })
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
        // Is the cursor above/below the right half of an element inside a horizontal stack
      } else if (rightOfChildHorizontalSpace) {
        const newHoverPosition = buildHoverPositionForBetweenSiblings({
          node: getNextDirectSiblingOfGridNode({
            currentNodeToCheck,
            mapOfChildIdsByParentId,
            mapOfPositionsById
          }),
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds),
          parentNode,
          previousSibling: currentNodeToCheck
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
      }
    } else if (currentNodeToCheck.type !== layoutNodeTypes.GRID_LAYOUT_ROOT && parentNode && parentNode.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK) {
      var _children$4, _children$at4;
      const hoverLocations = getHoverLocations(parentNode, adjustedMouseCoords);
      const closenessToAllEdges = computeClosenessToAllEdges(Object.assign({
        adjustedMouseCoords,
        currentNodeToCheck: parentNode,
        deepestHoveredNode
      }, hoverLocations));
      const siblings = getSiblings(parentNode, mapOfChildIdsByParentId, mapOfPositionsById);
      const children = getChildrenForCurrentNode(parentNode.id, mapOfChildIdsByParentId, mapOfPositionsById);
      const childrenIds = {
        firstChildId: (_children$4 = children[0]) === null || _children$4 === void 0 ? void 0 : _children$4.id,
        lastChildId: (_children$at4 = children.at(-1)) === null || _children$at4 === void 0 ? void 0 : _children$at4.id
      };
      const firstChildOfContainer = isFirstChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeToCheck.id);
      const lastChildOfContainer = isLastChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeToCheck.id);
      const isWithinVerticalSpaceOfNode = isPositionWithinBounds(adjustedMouseCoords, {
        top: currentNodeToCheck.top,
        bottom: currentNodeToCheck.bottom,
        left: parentNode.left,
        right: parentNode.right
      });
      const topOrBottomOfNode = determineTopOrBottomHalfPositionWithinBounds(adjustedMouseCoords, currentNodeToCheck);
      const topOfChild = adjustedMouseCoords.y < currentNodeToCheck.top;
      const topOfChildVerticalSpace = isWithinVerticalSpaceOfNode && topOrBottomOfNode === TOP;
      const bottomOfChild = adjustedMouseCoords.y > currentNodeToCheck.bottom;
      const bottomOfChildVerticalSpace = isWithinVerticalSpaceOfNode && topOrBottomOfNode === BOTTOM;

      // Is the cursor above the first element in a vertical stack
      if (firstChildOfContainer && (topOfChild || topOfChildVerticalSpace)) {
        const newHoverPosition = buildHoverPositionForBeforeChildren({
          node: parentNode,
          childrenIds,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds)
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
      } else if (
      // Is the cursor below the last element in a vertical stack
      lastChildOfContainer && (bottomOfChild || bottomOfChildVerticalSpace)) {
        const newHoverPosition = buildHoverPositionForAfterChildren({
          node: parentNode,
          childrenIds,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds)
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
        // Is the element to the left/right of the top half of an element in a vertical stack
      } else if (topOfChildVerticalSpace) {
        const newHoverPosition = buildHoverPositionForBetweenSiblings({
          node: currentNodeToCheck,
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds),
          parentNode,
          previousSibling: getPreviousDirectSiblingOfGridNode({
            currentNodeToCheck,
            mapOfChildIdsByParentId,
            mapOfPositionsById
          })
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
        // Is the element to the left/right of the bottom half of an element in a vertical stack
      } else if (bottomOfChildVerticalSpace) {
        const newHoverPosition = buildHoverPositionForBetweenSiblings({
          node: getNextDirectSiblingOfGridNode({
            currentNodeToCheck,
            mapOfChildIdsByParentId,
            mapOfPositionsById
          }),
          otherHoverPositionProps: Object.assign({}, hoverLocations, closenessToAllEdges, siblings, childrenIds),
          parentNode,
          previousSibling: currentNodeToCheck
        });
        if (newHoverPosition) {
          hoveredStack.push(newHoverPosition);
        }
      }
    }
  }
  hoveredStack.reverse();
  return hoveredStack;
};
export default calculateGridLayoutTreeHoverPositions;